module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Weight1-5347cf59b147fc1e8a9a05135dafc150.svg";